module.exports = __webpack_public_path__ + "img/oval.2b092887.svg";